<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48">
    <path
      :fill="color"
      d="m31.75 28.2-2.15-2.15 3.45-2.2L16.6 13.4V9.85l22 14Zm7.9 16.35L26.6 31.5l-10 6.35V21.5L3.5 8.35l2.1-2.1 36.2 36.2ZM19.6 24.75Zm0 7.65 4.65-2.95-4.65-4.7Zm-3-19Z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-add",
  components: {},
})
export class IconPlayDisabled extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconPlayDisabled;
</script>
